export default function getCookieByName(cname) {
  let match = document.cookie.match(new RegExp(cname + '=([^;]+)'))
  if (match) return match[1]
  return null
}



// WEBPACK FOOTER //
// ./src/modules/app/helpers/getCookieByName.js